module.exports = __webpack_public_path__ + "img/triangle-35.b5a9d5ab.gif";